module.exports = __webpack_public_path__ + "static/media/emptyCheckList.a23e1b7f.svg";